import PropTypes from 'prop-types';
import React, { memo } from 'react';
import classNames from 'classnames';

import { AppHeader, AppHeaderTitle } from '../AppHeader';
import { AppToolbar } from '../AppToolbar';

import style from './style.module.css';

const AppPageComponent = ({ overline, title, actions, toolbar, background, className, contentClassName, children }) => (
  <div className={classNames(style.host, className)} style={background ? { backgroundColor: background } : undefined}>
    <AppHeader actions={actions}>{title && <AppHeaderTitle overline={overline} title={title} />}</AppHeader>
    {toolbar && <AppToolbar>{toolbar}</AppToolbar>}
    <main className={classNames(style.content, contentClassName)}>{children}</main>
  </div>
);

AppPageComponent.propTypes = {
  actions: PropTypes.node,
  background: PropTypes.string,
  className: PropTypes.string,
  contentClassName: PropTypes.string,
  overline: PropTypes.node,
  title: PropTypes.node,
  toolbar: PropTypes.node,
};

/**
 * Full-height page shell: the app header with the page title, an optional page toolbar, and a content area
 * for the page cards. The content area is a flex column, so a card with `flex: 1` fills the remaining height.
 *
 * @param props.background Optional page background colour (e.g. The project pink).
 */
export const AppPage = memo(AppPageComponent);
